import {TRADE_PARTNER_HAS_TRADE_HISTORY} from '@modifi/plugin-onboarding'

const addressFields = ['city', 'countryCode', 'streetName', 'streetNumber', 'state', 'zipCode']

const hasTradeHistory = (data: Record<string, any>): boolean =>
  !!data?.[TRADE_PARTNER_HAS_TRADE_HISTORY]

export const shouldRenderTradingSinceFilter = hasTradeHistory

export const shouldRenderTotalExportVolumeFilter = hasTradeHistory

export const shouldRenderOutstandingVolumeFilter = hasTradeHistory

const inputFieldNameToProperty = (fieldName: string): string =>
  fieldName.replace('tradePartner.', '')

export const mapFormDataToRequest = (
  formData: Record<string, any>,
  isCreate?: boolean
): Record<string, any> => {
  const data = Object.fromEntries(
    Object.entries(formData).map(([fieldName, value]) => [
      inputFieldNameToProperty(fieldName),
      value,
    ])
  )
  const formattedData = Object.keys(data).reduce((finalData, dataKey) => {
    // to ignore temporary field
    if (dataKey === 'companyNameSearchSelect') {
      return finalData
    }
    // to format address fields
    if (addressFields?.includes(dataKey)) {
      return {
        ...finalData,
        address: {
          ...(finalData?.address || {}),
          [dataKey]: data[dataKey],
        },
      }
    }
    return {
      ...finalData,
      [dataKey]: data[dataKey],
    }
  }, {} as any)
  if (isCreate) {
    const {company, companyIds, expectedFinancingLimit, tradingCurrency, ...restData} =
      formattedData

    if (company) {
      // already formatted
      return formattedData
    }
    return {
      company: {
        ...restData,
      },
      expectedFinancingLimit: {
        amount: expectedFinancingLimit,
        currency: tradingCurrency,
      },
      ...(companyIds ? {companyIds} : {}), // companyIds will exist for buyer selected from dropdown
    }
  }

  const {expectedFinancingLimit, tradingCurrency, ...restData} = formattedData
  if (expectedFinancingLimit === undefined && tradingCurrency === undefined) {
    return formattedData
  }
  // the limit and its currency are two separate form fields, but are sent as a single amount object
  return {
    ...restData,
    expectedFinancingLimit: {
      amount: expectedFinancingLimit,
      currency: tradingCurrency,
    },
  }
}
